export default __webpack_public_path__ + "static/media/offers.813f1cf1.svg";